import type { PropsValue } from 'react-select';

export function isSingleOption<TValue>(
  option: PropsValue<TValue>,
): option is TValue {
  return option !== null && option !== undefined && !Array.isArray(option);
}
